<template>
  <div class="altura">
    <b-row no-gutters>
      <b-col cols="12" class="mb-2 mb-lg-4">
        <PageTitle class="mt-2" title="Privacidade" />
      </b-col>
    </b-row>
    <TermsAndPrivacyComponent
      :isTerm="false"
     />
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import TermsAndPrivacyComponent from '@/components/Shopkeeper/TermsAndPrivacyComponent.vue';

export default {
  name: 'Privacidade',

  components: {
    PageTitle,
    TermsAndPrivacyComponent,
  },
}
</script>

<style scoped>
.altura {
  min-height: 80vh;
}
</style>